"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = _default;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
function _default(_ref) {
  var width = _ref.width,
    height = _ref.height,
    color = _ref.color,
    rotate = _ref.rotate,
    className = _ref.className,
    _ref$dataTestid = _ref['data-testid'],
    dataTestId = _ref$dataTestid === void 0 ? 'icon' : _ref$dataTestid;
  return /*#__PURE__*/_react["default"].createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    className: "".concat(className, " icon icon--navigation fill-").concat(color),
    style: {
      width: "".concat(width, "px"),
      transform: "rotate(".concat(rotate, "deg)"),
      height: "".concat(height, "px")
    },
    viewBox: "0 0 24 24",
    "data-testid": dataTestId
  }, /*#__PURE__*/_react["default"].createElement("path", {
    fillRule: "evenodd",
    d: "M4.31 10.753h12.185l-3.833-3.606a1.219 1.219 0 010-1.787c.51-.48 1.326-.48 1.836 0l6.112 5.75c.52.49.52 1.29 0 1.78l-6.112 5.75c-.51.48-1.326.48-1.836 0a1.209 1.209 0 010-1.778l3.833-3.607H4.31c-.703 0-1.31-.545-1.31-1.25 0-.707.607-1.252 1.31-1.252zm13.142.379H4.31h13.142zm-4.526-5.498a.965.965 0 011.308 0l6.112 5.75-6.112-5.75a.965.965 0 00-1.308 0z",
    clipRule: "evenodd"
  }));
}